/**
 * List of known environment names.
 */
module.exports = {
  development: 'development',
  production: 'production',
  test: 'test',
};
